import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import Select from '../ui/Select';
import useSystemSettings from '../hooks/useSystemSettings';
import useSuntekSettings from '../hooks/useSuntekSettings';
import { getFmsGlobal } from '../globals';

function BranchDropDown({
  value,
  onChange = () => {},
  disabled = false,
  isSetup = false,
  selectId = undefined,
  addAll = false,
  maxLength = undefined,
  name = undefined,
  inactive = false,
  addBlank = true,
  isReport = false,
  viewOnly = false,
}: {
  value: string,
  onChange?: (x: string) => void,
  disabled?: boolean,
  isSetup?: boolean,
  selectId?: string,
  addAll?: boolean,
  maxLength?: number,
  name?: string,
  inactive?: boolean,
  addBlank?: boolean,
  isReport?: boolean,
  viewOnly?: boolean,
}) {
  const systemSettings = useSystemSettings();
  const suntekSettings = useSuntekSettings();
  const fmsGlobal = getFmsGlobal();

  const hqBranch = suntekSettings.company?.hqBranch ?? '';
  const userBranch = systemSettings?.userBranch ?? '';
  const { enableBranch } = systemSettings;

  const branchDetails = inactive ? systemSettings.branchDetails : systemSettings.branchDetails?.filter(x => !x.inactive);

  const isRestrictedToUserBranch = !isReport && (viewOnly ? fmsGlobal.NoShowAllBranchData : fmsGlobal.NoShowAllBranchData || fmsGlobal.NoEditAllBranchData);

  const branchOptions = (branchDetails ?? [])
    .map(x => x.branch)
    .filter(branch => !isRestrictedToUserBranch || branch === userBranch)
    .map(branch => ({
      value: branch,
      label: branch === hqBranch ? `${branch} (HQ)` : branch,
    }));

  const showAllOption = addAll && !(viewOnly && fmsGlobal.NoShowAllBranchData) && !(isReport && fmsGlobal.NoBranchSelection);

  const displayData = isSetup || enableBranch
    ? [
        ...(addBlank ? [{ value: '', label: '' }] : []),
        ...(showAllOption ? [{ value: 'ALL', label: 'ALL' }] : []),
        ...branchOptions,
      ]
    : [];

  // disabled 여부
  const isCurrentValueLocked =
    !viewOnly &&
    fmsGlobal.NoEditAllBranchData &&
    !_.isEmpty(value) &&
    value !== userBranch &&
    !(addAll && value === 'ALL');

  const isDisabled = isSetup
    ? disabled
    : disabled ||
      !enableBranch ||
      (isReport && fmsGlobal.NoBranchSelection) ||
      isCurrentValueLocked;

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange(e.target.value);
  }

  return (
    <Select
      selectId={selectId}
      name={name}
      value={value}
      onChange={handleChange}
      disabled={isDisabled}
      items={displayData}
      maxLength={maxLength}
    />
  );
}

BranchDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
  isSetup: false,
  inactive: false,
  isReport: false,
};

BranchDropDown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  selectId: PropTypes.string,
  isSetup: PropTypes.bool.isRequired,
  inactive: PropTypes.bool,
  isReport: PropTypes.bool.isRequired,
};

export default BranchDropDown;